import { useState } from "react";
// import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { Modal } from "antd";
import DaumPostcode from "react-daum-postcode";

// 다국어
import { useTranslation } from 'react-i18next';

export default function PostcodeModalPopup(props) {

  const setAddress = props.setAddress;
  const setZipCode = props.setZipCode;

  // 다국어
  const { t, i18n } = useTranslation(['page']);
  
  const [isOpen, setIsOpen] = useState(false);

  const onToggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  const handleComplete = (data) => {
    console.log(data);

    let fullAddress = data.address;
      let extraAddress = '';
  
      if (data.addressType === 'R') {
        if (data.bname !== '') {
          extraAddress += data.bname;
        }
        if (data.buildingName !== '') {
          extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
        }
        fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
      }
  
      console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
      setAddress(fullAddress);
      setZipCode(data.zonecode);

    onToggleModal(); // 주소창은 자동으로 사라지므로 모달만 꺼주면 된다.
  };
  
  return (
    <>
      <Button type="primary" onClick={onToggleModal}>
        {t('주소 검색')}
      </Button>
      {isOpen && (
        <Modal
          visible
          onOk={onToggleModal}
          onCancel={onToggleModal}
          width={700}
          centered
          closable={false}
          footer={null}
        >
          <DaumPostcode onComplete={handleComplete} />
        </Modal>
      )}
    </>
  );
}

